import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';

import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { AddAnnualReturnEligibleUserComponent } from './add-annual-return-eligible-user/add-annual-return-eligible-user.component';
import { AnnualAccountComponentComponent } from './annual-account-component/annual-account-component.component';
import { AnnualReturnListComponentComponent } from './annual-return-list-component/annual-return-list-component.component';
import { AnnualReturnSubmissionComponentComponent } from './annual-return-submission-component/annual-return-submission-component.component';
import { AnnualReturnSubmissionHistoryFormAdminComponent } from './annual-return-submission-history-form-admin/annual-return-submission-history-form-admin.component';
import { AnnualReturnSubmissionHistoryMemberFormComponent } from './annual-return-submission-history-member-form/annual-return-submission-history-member-form.component';
import { DirectorDetailsComponentComponent } from './director-details-component/director-details-component.component';
import { AttachScannedCopiesComponentComponent } from './attach-scanned-copies-component/attach-scanned-copies-component.component';
import { AnnualReturnsEligibleUserComponent } from './annual-returns-eligible-user/annual-returns-eligible-user.component';
import { AnnualSubmissionToExchangeComponentComponent } from './annual-submission-to-exchange-component/annual-submission-to-exchange-component.component';
import { ListedInComponentComponent } from './listed-in-component/listed-in-component.component';
import { NetworthComponentComponent } from './networth-component/networth-component.component';
import { OtherStockExchangeComponentComponent } from './other-stock-exchange-component/other-stock-exchange-component.component';
import { PrincipalOfficerDetailsComponentComponent } from './principal-officer-details-component/principal-officer-details-component.component';
import { ShareHoldingCorporateComponentComponent } from './share-holding-corporate-component/share-holding-corporate-component.component';
import { ShareHoldingDetailsComponentComponent } from './share-holding-details-component/share-holding-details-component.component';




@NgModule({
  declarations: [  AddAnnualReturnEligibleUserComponent,AnnualAccountComponentComponent,AnnualReturnListComponentComponent,
    AnnualReturnSubmissionComponentComponent,AnnualReturnSubmissionHistoryFormAdminComponent,AnnualReturnSubmissionHistoryMemberFormComponent,
    AnnualReturnsEligibleUserComponent,AnnualSubmissionToExchangeComponentComponent,AttachScannedCopiesComponentComponent,DirectorDetailsComponentComponent,
    ListedInComponentComponent,NetworthComponentComponent,OtherStockExchangeComponentComponent,PrincipalOfficerDetailsComponentComponent,
    ShareHoldingCorporateComponentComponent,ShareHoldingDetailsComponentComponent

  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class AnnualReturnModule { }
